import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { hideLoader, showLoader } from "./loaderSlice";
import { uploadFile } from "../../utils/uploadFiles";
import endPoints from "../../shared/services/endPoints";
import api from "../../shared/services/api";
import { getProfileAction } from "../actions/user.actions";
import { showToast } from "./toastSlice";

const initialState = {
  profile: {},
  notifications: [],
  unreadNotificationsCount: 0,
};

export const updateUserProfile = createAsyncThunk(
  "user/updateProfile",
  async ({ data, setVisible }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      if (data?.image && data?.image instanceof File) {
        const image = await uploadFile(data.image);
        data.image = image.path;
      }

      const response = await api("put", endPoints.UPDATE_PROFILE, {
        ...data,
      });

      if (response.success) {
        thunkAPI.dispatch(getProfileAction());
      }
      if (setVisible) setVisible(false);
      thunkAPI.dispatch(hideLoader());
      return response.data;
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const changeUserPassword = createAsyncThunk(
  "user/changePassword",
  async ({ data, setVisible }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      if (data?.image && data?.image instanceof File) {
        const image = await uploadFile(data.image);
        data.image = image.path;
      }

      const response = await api("post", endPoints.CHANGE_PASSWORD, {
        ...data,
      });

      thunkAPI.dispatch(hideLoader());

      if (response.success) {
        if (setVisible) setVisible(false);
        thunkAPI.dispatch(getProfileAction());
      } else {
        thunkAPI.dispatch(
          showToast({ type: "error", message: response.message })
        );
      }
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchUserNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (setData) => {
    const response = await api("get", endPoints.NOTIFICATIONS);
    if (setData) setData(response.data);
    return response.data;
  }
);

export const fetchUnreadNotificationsCount = createAsyncThunk(
  "notifications/fetchUnreadNotificationsCount",
  async () => {
    const response = await api("get", endPoints.UNREAD_NOTIFICATIONS_COUNT);
    return response.data;
  }
);

export const markNotificationAsRead = createAsyncThunk(
  "user/markNotificationAsRead",
  async ({ id, setData }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());

      const response = await api(
        "put",
        endPoints.MARK_NOTIFICATION_AS_READ + id
      );

      thunkAPI.dispatch(hideLoader());
      if (response.success) {
        thunkAPI.dispatch(fetchUnreadNotificationsCount());
        thunkAPI.dispatch(fetchUserNotifications(setData));
      }
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const chatBotUserChat = createAsyncThunk(
  "user/chatBotUserChat",
  async ({ question, prevChat, setChat, setLoading }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      setLoading && setLoading(true)
      const response = await api("post", endPoints.CHAT_BOT, {
        message: question,
      });

      // thunkAPI.dispatch(hideLoader());
      setLoading && setLoading(false)
      if (response.success) {
        prevChat[prevChat.length - 1] = {
          ...prevChat[prevChat.length - 1],
          // answer: response.data.fulfillmentText,
          answer: response.data?.response,
        };
        setChat && setChat([...prevChat]);

        // return response?.data?.response;
      }
    } catch (error) {
      console.log("error", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      state.profile = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserNotifications.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchUserNotifications.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.notifications = action.payload;
      })
      .addCase(fetchUserNotifications.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      })
      .addCase(fetchUnreadNotificationsCount.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchUnreadNotificationsCount.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.unreadNotificationsCount = action.payload?.notificationCount;
      })
      .addCase(fetchUnreadNotificationsCount.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      });
  },
});

export const { setUserProfile } = userSlice.actions;

export default userSlice.reducer;
